import { request } from './client';
import type {
  Dashboard,
  Well,
} from '../types';

/** Wells and their dashboards. */
export const wellsApi = {
  /**
   * The API answers collections as {items, total} while the mock used to answer
   * a bare array. Unwrapping here rather than at every call site means one
   * shape reaches the components — and a mismatch cannot take the whole app
   * down, which is exactly what it did: Header called .find on an object.
   */
  list: async () => {
    const res = await request<Well[] | { items: Well[] }>('/wells');
    return Array.isArray(res) ? res : (res?.items ?? []);
  },

  dashboard: (wellId: number) => request<Dashboard>(`/wells/${wellId}/dashboard`),
};
